import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import WDT_STUDENT_SETTINGS from 'graph/reports/wdt-student-settings-report-query';
import GET_WDT_CLASSROOM_SETTINGS from 'graph/settings/wdt/get-wdt-classroom-settings-query';
import DetailsCard from 'components/@common/Cards/DetailsCard';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { useLazyQuery } from '@apollo/client';
import { WdtCharacterOrder } from 'types/schema-generated-types';

const StudentSettingsCard: React.FC = () => {
  const { t } = useTranslation('Reports');
  const [{ entityId }] = useReportQueryParams();
  const [
    fetchStudentSettings,
    { data: studentSettingsData, loading: loadingStudentSettings }
  ] = useLazyQuery(WDT_STUDENT_SETTINGS);

  const [
    fetchClassroomSettings,
    { data: classroomSettingsData, loading: loadingClassroomSettings }
  ] = useLazyQuery(GET_WDT_CLASSROOM_SETTINGS);

  const loading = loadingStudentSettings || loadingClassroomSettings;

  const teachingOrder = loading
    ? ''
    : studentSettingsData?.wdtStudentSettings.characterOrder?.lowercase ??
      classroomSettingsData?.wdtClassroomSettings?.characterOrder?.lowercase ??
      WdtCharacterOrder.hwt;

  const studentSettings = {
    title: {
      label: t('Student Settings'),
      helpText: t('wdtStudentSettings', { ns: 'ReportsHelpCommon' })
    },
    sections: [
      {
        label: t('Teaching Order'),
        value: t(teachingOrder, {
          ns: 'WdtCharacterOrder'
        })
      },
      {
        label: t('Left Handed'),
        value: studentSettingsData?.wdtStudentSettings.handedness?.leftHanded ? t('Yes') : t('No')
      }
    ]
  };

  useEffect(() => {
    fetchStudentSettings({ variables: { studentId: entityId } });
  }, [fetchStudentSettings, entityId]);

  useEffect(() => {
    if (
      !studentSettingsData?.wdtStudentSettings.characterOrder?.lowercase &&
      studentSettingsData?.student?.classrooms?.length > 0
    ) {
      fetchClassroomSettings({
        variables: {
          where: {
            classroomId: Number(studentSettingsData.student.classrooms[0].id)
          }
        }
      });
    }
  }, [fetchClassroomSettings, studentSettingsData]);

  return (
    <DetailsCard
      title={studentSettings.title}
      sections={studentSettings.sections}
      loading={loading}
    />
  );
};

export default StudentSettingsCard;
